import api from './api';
import { UserRole, VerificationStatus, AuditLogEntry } from '../types/models';

export interface AdminUser {
  userId: string;
  email: string;
  name: string;
  roles: UserRole[];
  accountStatus: 'active' | 'disabled' | 'pending';
  createdAt: string;
  syncStatus: 'ok' | 'cognito_only';
  verificationStatus?: VerificationStatus;
}

export async function listUsers(): Promise<AdminUser[]> {
  const res = await api.get('/admin/users');
  return res.data.users;
}

export async function repairUser(userId: string): Promise<void> {
  await api.post(`/admin/users/${userId}/repair`);
}

export async function updateUserRoles(userId: string, roles: UserRole[]): Promise<void> {
  await api.put(`/admin/users/${userId}/roles`, { roles });
}

export async function updateUserStatus(userId: string, status: 'active' | 'disabled'): Promise<void> {
  await api.put(`/admin/users/${userId}/status`, { status });
}

export async function setTeacherVerificationStatus(
  userId: string,
  verificationStatus: 'provisional' | 'verified' | 'rejected',
  notes?: string,
): Promise<void> {
  await api.put(`/admin/teachers/${userId}/verification`, { verificationStatus, ...(notes ? { notes } : {}) });
}

export async function listAuditLogs(params: {
  limit?: number;
  before?: string;
  targetUserId?: string;
} = {}): Promise<{ logs: AuditLogEntry[]; nextBefore?: string }> {
  const qs = new URLSearchParams();
  if (params.limit) qs.set('limit', String(params.limit));
  if (params.before) qs.set('before', params.before);
  if (params.targetUserId) qs.set('targetUserId', params.targetUserId);
  const query = qs.toString() ? `?${qs.toString()}` : '';
  const res = await api.get(`/admin/audit-logs${query}`);
  return res.data;
}
